import { render } from "./GibergCustomMade.vue?vue&type=template&id=43a4de8a&scoped=true"
import script from "./GibergCustomMade.vue?vue&type=script&lang=js"
export * from "./GibergCustomMade.vue?vue&type=script&lang=js"

import "./GibergCustomMade.vue?vue&type=style&index=0&id=43a4de8a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43a4de8a"]])

export default __exports__